import { Tabs } from 'components/ideal-core-ui'
import { HtmlTemplates } from './HtmlTemplates'
import { WordTemplates } from './WordTemplates'
import s from './SelectTemplate.scss'

const SelectTemplate = ({
  userHtmlTemplates,
  selectedTemplate,
  setSelectedTemplate,
  iDealHtmlTemplates,
  userWordTemplates,
  iDealWordTemplates
}) => {
  return (
    <Tabs
      className={s.tabContainer}
      noPadding
      keepState
      activeTabKey={selectedTemplate?.proposalType ?? 'HTML'}
      tabs={[
        {
          key: 'HTML',
          label: 'Html Proposal Templates',
          cb: () => setSelectedTemplate(() => null),
          value: (
            <HtmlTemplates
              userHtmlTemplates={userHtmlTemplates}
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
              iDealHtmlTemplates={iDealHtmlTemplates}
            />
          )
        },
        {
          key: 'WORD',
          label: 'Word Proposal Templates',
          cb: () => setSelectedTemplate(() => null),
          value: (
            <WordTemplates
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
              userWordTemplates={userWordTemplates}
              iDealWordTemplates={iDealWordTemplates}
            />
          )
        }
      ]}
    />
  )
}

export default SelectTemplate
